import { render, staticRenderFns } from "./GridAttributes.vue?vue&type=template&id=172c0712&"
import script from "./GridAttributes.vue?vue&type=script&lang=js&"
export * from "./GridAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('172c0712')) {
      api.createRecord('172c0712', component.options)
    } else {
      api.reload('172c0712', component.options)
    }
    module.hot.accept("./GridAttributes.vue?vue&type=template&id=172c0712&", function () {
      api.rerender('172c0712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/attributes/grid/GridAttributes.vue"
export default component.exports